module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg"
  }, [_c('div', {
    staticClass: "msg-header",
    style: ({
      background: _vm.skinColor
    })
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.hiddenMsg
    }
  }), _vm._v("消息中心\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "msg-content"
  }, [_c('div', {
    staticClass: "msg-read"
  }, _vm._l((_vm.msgReadTabs), function(msgReadTab, index) {
    return _c('div', {
      key: index,
      staticClass: "msgReadTab",
      class: {
        active: _vm.tag === msgReadTab.tag
      },
      style: ({
        background: _vm.tag === msgReadTab.tag ? _vm.skinColor.replace(/\sl[\S\s]+/, '').replace(/(1)(\))/, '0.2$2') : '',
        borderBottomColor: _vm.skinColor.replace(/\sl[\S\s]+/, ''),
      }),
      on: {
        "click": function($event) {
          _vm.changeTab(msgReadTab.tag)
        }
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(msgReadTab.title))]), _vm._v(" "), _c('span', {
      staticClass: "length",
      style: ({
        background: _vm.skinColor
      })
    }, [_vm._v(_vm._s(msgReadTab.messages))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "msg-list"
  }, [_c('transition-group', {
    attrs: {
      "name": "show"
    }
  }, _vm._l(((_vm.tag === 'unread' ? _vm.msg.hasnot_read_messages : _vm.msg.has_read_messages)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "msg-item"
    }, [_c('div', {
      staticClass: "msg-author-avatar"
    }, [_c('div', {
      staticClass: "avatar "
    }, [_c('span', {
      staticClass: "img-border",
      style: ({
        borderTopColor: _vm.skinColor.replace(/\sl[\S\s]+/, ''),
        borderRightColor: _vm.skinColor.replace(/\sl[\S\s]+/, '')
      })
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item ? item.author.avatar_url : ''),
        expression: "item ? item.author.avatar_url : ''"
      }],
      staticClass: "avatar-img",
      attrs: {
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "msg-reply"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": {
          name: 'User',
          params: {
            name: item.author.loginname
          }
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.author.loginname) + "\n                      ")]), _vm._v("\n                      回复你的话题\n                      "), _c('router-link', {
      staticClass: "title",
      attrs: {
        "to": {
          name: 'Article',
          params: {
            id: item.topic.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.markOne(item.id)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.topic.title) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "msg-data"
    }, [_vm._v("\n                          " + _vm._s(_vm.changeTime(item.create_at)) + "                               \n                      ")])], 1)])
  }))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6bb46b84"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Msg/Msg.vue
// module id = 333
// module chunks = 4